/**
 * Event Smooth Scroll
 */

export function initSmoothScroll(): void {
  const links = document.querySelectorAll<HTMLElement>('[data-scroll-to]');

  links.forEach((link) => {
    link.addEventListener('click', (e: Event) => {
      e.preventDefault();

      const targetId = link.getAttribute('data-scroll-to');
      if (!targetId) return;

      const target = document.getElementById(targetId);

      // Close scroll toast when scrolling
      const scrollToast = document.querySelector<HTMLElement>('[data-scroll-toast]');
      if (scrollToast && !scrollToast.hidden) {
        scrollToast.hidden = true;
      }

      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });

        const firstInput = target.querySelector<HTMLInputElement>('input:not([type="hidden"])');
        if (firstInput) {
          setTimeout(() => firstInput.focus(), 500);
        }
      }
    });
  });
}
